export class ClienteSAE {
    idCliente: number;
    RFC: string;
    calle?: string;
    codigoPostal?: string;
    colonia: string;
    manejaCredito: number;
    diasCredito: number;
    email: string;
    lada: string;
    lenguaje: string;
    nombre: string;
    nombreCorto?: string;
    idCiudad: number;
    idEstado: number;
    idPais: number;
    numExterior?: string;
    numeroCliente: string;
    telefono: string;
    tipoPersona: number;
    idTipoCliente: number;
    idUsuario?: number;
    loacs?: string;
    BILL_TAX_REGIME_ID: number;

    LOCATION_ID:number;
    SUBURB_ID:number;
    POSTAL_CODE_ID:number;

    BILL_CFDI_USE_ID:number;
}



// WEBPACK FOOTER //
// ./src/app/models/cliente-sae.ts